// // **********************************************************
// // Color Selector
// // **********************************************************
//
// document.querySelectorAll('.color-selector').forEach((colorSelector) => {
//   const selectedColor = colorSelector.querySelector('[data-selected-color]');
//   const inputs = colorSelector.querySelectorAll('input');
//
//   // Check on load if any input is already checked
//   const checkedInput = Array.from(inputs).find((input) => input.checked);
//   if (checkedInput && selectedColor) {
//     const selectedText = checkedInput.getAttribute('data-text');
//     if (selectedText) selectedColor.textContent = selectedText;
//   }
//
//   // Add change event listener to update text on selection
//   inputs.forEach((input) => {
//     input.addEventListener('change', () => {
//       const selectedText = input.getAttribute('data-text');
//       if (selectedColor && selectedText) {
//         selectedColor.textContent = selectedText;
//       }
//     });
//   });
// });
